<template>
  <i v-if="isRelevant" class="tm-visual-empty-scene" :style="styleObj">
    <i class="-odp-mask">
      <i class="-odp-border">
        <i class="-odp-copy">Drop Media<br />anywhere on the scene</i>
      </i>
    </i>
  </i>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'tm-visual-empty-scene',

  props: {
    rectangle: { type: Object, required: true },
    isRelevant: { type: Boolean, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      sceneTrack: (state) => state.sceneEscort.sceneTrack,
      pxOverlayTopOffset: (state) => state.cssVariables.pxOverlayTopOffset,
    }),

    styleObj() {
      let width = 150;
      let point = null;

      if (this.$props.rectangle.width < width) {
        point = this.$props.rectangle.p1;
        width = this.$props.rectangle.width;
      } else {
        point = this.$props.rectangle.getCenterPoint();
        point.x -= width / 2;
        point.y = this.$props.rectangle.p1.y;
      }

      return {
        transform: `translate3d(${point.x}px, ${
          point.y + this.pxOverlayTopOffset
        }px, ${0})`,
        width: `${width}px`,
      };
    },
  },
};
</script>

<style lang="scss">
.tm-visual-span .tm-visual-empty-scene {
  position: absolute;
  pointer-events: none;
  overflow: hidden;
  z-index: var(--tm-zVisualEmptyScene);

  > .-odp-mask {
    min-width: 150px;
    padding: 3px;
    height: var(--tm-pxOverlayH);
    background-color: var(--tm-rulerColour);
    display: flex;
    justify-content: center;
    align-content: center;
    animation: scale-in 0.5s;

    @keyframes scale-in {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }

    > .-odp-border {
      border: 2px dashed #fff;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-flow: column;
      text-align: center;
      width: 100%;

      > .-odp-copy {
        color: #fff;
        font-size: 12px;
      }
    }
  }
}
</style>
